// extracted by mini-css-extract-plugin
module.exports = {"list":"list___36nHu","item":"item___1ikHn"};